import { z } from "zod";
import { getOrganizationSchema } from "../../organization";

export const getPartnershipReportParamSchema = z
	.object({
		partnershipId: z.uuid(),
		reportId: z.uuid(),
	})
	.and(getOrganizationSchema);

export type GetPartnershipReportParamSchema = z.infer<typeof getPartnershipReportParamSchema>;
